export class Country {
  public translationKey!: string;
  public countryCode!: string;
  public zipCodePattern?: RegExp;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}
